// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 972) return "static/chunks/972-967eaf3477941445.js";
	if (chunkId === 145) return "static/chunks/145-37839f5bc77e7913.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"88":"844f6a9e18e4775a","186":"dcd1301e6a1367ae","239":"c1a6adf280c0ff8d","289":"fecbc9b0dd8f0c8c","846":"2e4933f1fcdb4702"}[chunkId] + ".js";
};